<template class="full-height">
  <div
    class="accountsPayableManagement-app-container"
    style="position: relative; height: 100%; padding: 10px"
  >
    <!-- <el-switch
    @change="showEscroll"
    v-model="doing"
    active-color="#13ce66"
    inactive-color="#ff4949"
    :active-value="true"
    :inactive-value="false">
  </el-switch> -->
    <el-dialog
      @closed="currentTravelID = null"
      append-to-body
      modal-append-to-body
      v-loading="dialogNoteLoading"
      :top="dialogTopMargin"
      :title="`${currentTravelName} 旅客使用紀錄`"
      :visible.sync="travelersDetailsDialogNoteVisible"
      width="60%"
    >
      <TravelersUsed :travelID="currentTravelID" :travelName="currentTravelName"></TravelersUsed>
      <span slot="footer" class="dialog-footer">
        <el-button @click="travelersDetailsDialogNoteVisible = false" type="danger"
          >關 閉</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      v-if="currentAgencyReceivableListRow"
      v-loading="dialogNoteLoading"
      :top="dialogTopMargin"
      :title="`${currentAgencyReceivableListRow.agencyName}備註管理`"
      :visible.sync="dialogNoteVisible"
      width="60%"
      @closed="onNoteDialogClosed"
    >
      <el-row>
        <el-col :span="24"
          ><el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="font-size: 17px; user-select: auto; color: blue; font-weight: bold"
                >備註管理</span
              >
              <!-- <el-button style="float: right; padding: 3px 0" type="text"
                >選擇檔案</el-button
              > -->
            </div>

            <div>
              <tinymce
                v-model="currentAgencyReceivableListRow.note.content"
                ref="tinymce"
                :height="300"
                :type="27"
              />
            </div> </el-card
        ></el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="success" @click="savePaymentInvoiceNote">儲 存</el-button>

        <el-button @click="dialogNoteVisible = false" size="mini" type="danger">關 閉</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-if="currentAgencyReceivableListRow && currentAgencyReceivableListRow.invoiceInfo"
      v-loading="dialogFileLoading"
      :top="dialogTopMargin"
      title="檔案上傳"
      :visible.sync="dialogFileVisible"
      width="50%"
      @close="onDialogClosed"
    >
      <el-row>
        <el-col :span="12"
          ><el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="font-size: 17px; user-select: auto; color: blue; font-weight: bold"
                >請款單</span
              >
              <!-- <el-button style="float: right; padding: 3px 0" type="text"
                >選擇檔案</el-button
              > -->

              <div style="float: right">
                <Upload
                  ref="uploadRef1"
                  :payload="currentAgencyReceivableListRow.invoiceInfo"
                  :data-obj="fileObj"
                  :limit-file-count="10"
                  :use-drag="false"
                  :action="'Agency/saveFile'"
                  :auto-upload="false"
                  :show-file-list="true"
                  :btn-txt="'選擇檔案'"
                  :before-file-list="formData.file1"
                />
              </div>
            </div> </el-card
        ></el-col>
        <el-col :span="12"
          ><el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="font-size: 17px; user-select: auto; color: blue; font-weight: bold">
                發票</span
              >
              <div style="float: right">
                <Upload
                  ref="uploadRef2"
                  :payload="formData"
                  :data-obj="fileObj"
                  :limit-file-count="10"
                  :use-drag="false"
                  :action="'Agency/saveFile'"
                  :auto-upload="false"
                  :show-file-list="true"
                  :btn-txt="'選擇檔案'"
                  :before-file-list="formData.file2"
                />
              </div>
            </div> </el-card
        ></el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveData" size="mini" type="success">儲 存</el-button>

        <el-button @click="dialogFileVisible = false" size="mini" type="danger">關 閉</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :fullscreen="true"
      v-if="currentAgencyReceivableListRow && currentAgencyReceivableListRow.invoiceInfo"
      v-loading="dialogFileLoading"
      :top="dialogTopMargin"
      :title="`${currentAgencyReceivableListRow.agencyName} 統計區間：${currentAgencyReceivableListRow.invoiceInfo.dateRangeInfo} 總金額：${currentAgencyReceivableListRow.pricing.totalPriceTaxStr}`"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <div style="position: relative; height: 100%">
        <el-table
          v-loading="listLoading"
          size="mini"
          :data="currentAgencyReceivableListRow.invoiceInfo.data"
          border
          fit
          highlight-current-row
          height="100%"
        >
          <el-table-column align="center" label="項次" width="60">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="left" label="總金額(含稅)" width="130">
            <template slot-scope="scope">
              <span
                style="font-size: 15px; color: #1890ff; font-weight: bold"
                v-if="scope.row.pricing"
                >{{ scope.row.pricing.totalPriceTaxStr }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" label="App金額(含稅)" width="130">
            <template slot-scope="scope">
              <span
                style="font-size: 15px; color: #1890ff; font-weight: bold"
                v-if="scope.row.pricing"
                >{{ scope.row.pricing.appUseTotalPriceTaxStr }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" label="App金額(未稅)" width="130">
            <template slot-scope="scope">
              <span
                style="font-size: 15px; color: #1890ff; font-weight: bold"
                v-if="scope.row.pricing"
                >{{ scope.row.pricing.appUseTotalPriceStr }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" label="App金額(稅金)" width="150">
            <template slot-scope="scope">
              <span
                v-if="scope.row.pricing"
                style="font-size: 15px; color: green; font-weight: bold"
                >{{ scope.row.pricing.appUseTotalTaxStr }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" label="網卡金額(含稅)" width="130">
            <template slot-scope="scope">
              <span
                style="font-size: 15px; color: #1890ff; font-weight: bold"
                v-if="scope.row.pricing"
                >{{ scope.row.pricing.networkCardUseTotalPriceTaxStr }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" label="網卡金額(未稅)" width="130">
            <template slot-scope="scope">
              <span
                style="font-size: 15px; color: #1890ff; font-weight: bold"
                v-if="scope.row.pricing"
                >{{ scope.row.pricing.networkCardUseTotalPriceStr }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" label="網卡金額(稅金)" width="150">
            <template slot-scope="scope">
              <span
                v-if="scope.row.pricing"
                style="font-size: 15px; color: green; font-weight: bold"
                >{{ scope.row.pricing.networkCardTotalTaxStr }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" label="網卡運費(含稅)" width="150">
            <template slot-scope="scope">
              <span
                v-if="scope.row.pricing"
                style="font-size: 15px; color: #1890ff; font-weight: bold"
                >{{ scope.row.pricing.networkCardPostFeePriceTaxStr }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" label="網卡運費(未稅)" width="150">
            <template slot-scope="scope">
              <span
                v-if="scope.row.pricing"
                style="font-size: 15px; color: #1890ff; font-weight: bold"
                >{{ scope.row.pricing.networkCardPostFeePriceStr }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="left" label="網卡運費(稅金)" width="150">
            <template slot-scope="scope">
              <span
                v-if="scope.row.pricing"
                style="font-size: 15px; color: green; font-weight: bold"
                >{{ scope.row.pricing.networkCardPostFeeTaxStr }}</span
              >
            </template>
          </el-table-column>

          <el-table-column align="center" label="團號" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.tourGroupNo }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="出團日" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.beginDate }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="結束日" width="110">
            <template slot-scope="scope">
              <span>{{ scope.row.endDate }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="團名" width="350">
            <template slot-scope="{ row }">
              <span>{{ row.travelName }}</span>
              <div>
                <el-tag>
                  出發{{ `${row.beginDate} ${row.beginTime}` }} - 回程{{
                    `${row.endDate} ${row.endTime}`
                  }}
                </el-tag>
              </div>
            </template>
          </el-table-column>

          <el-table-column align="center" label="狀態" width="110">
            <template slot-scope="scope">
              <el-tag :type="statusTranslateStyle(scope.row.status)">{{
                scope.row.statusDesc
              }}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" label="天數" width="80">
            <template slot-scope="scope">
              <span style="font-size: 17px">{{ scope.row.totalday }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="旅客數" width="80">
            <template slot-scope="scope">
              <span style="font-size: 17px">{{ scope.row.tourist }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="基本單價" width="80">
            <template>
              <span style="font-size: 17px">{{ 20 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="網卡數量" width="80">
            <template slot-scope="scope" v-if="scope.row.networkCardSouece">
              <span style="font-size: 17px">{{ scope.row.networkCardCount }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="網卡項目單價" width="180">
            <template slot-scope="scope" v-if="scope.row.networkCardSouece">
              <span>{{
                `${scope.row.networkCardSouece.cardName} ，$${scope.row.networkCardSouece.price}`
              }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="使用旅客名單" width="160">
            <template slot-scope="scope">
              <el-button @click="getTravelersDetails(scope.row)" type="success"
                >使用旅客名單</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="dialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <!-- <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      v-if="currentAgencyReceivableRow"
      width="80%"
    >
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-alert :closable="false" type="success" effect="dark">
            <template slot="title">
              <span
                style="font-size: 20px; font-weight: bolder"
                v-if="currentAgencyReceivableRow.pricing"
                >{{
                  `總金額：${currentAgencyReceivableRow.pricing.totalPriceTax}`
                }}</span
              >
            </template>
          </el-alert>
          <el-tag size="mini"
            >計算區間：{{ currentAgencyReceivableRow.dateRangeInfo }}</el-tag
          >
          <el-button
            @click="openFileDialog"
            size="mini"
            style="float: right; padding: 3px 0"
            type="text"
            >上傳檔案</el-button
          >
        </div>

        <div>
          <div style="position: relative; height: 80%">
            <el-table
              v-loading="listLoading"
              size="mini"
              :data="currentAgencyReceivableRow.data"
              border
              fit
              highlight-current-row
              height="100%"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                label="App+網卡總金額(含稅)"
                width="150"
              >
                <template slot-scope="scope">
                  <span class="tax-price" v-if="scope.row.pricing">{{
                    scope.row.pricing.totalPriceTax
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                label="App+網卡總金額(未稅)"
                width="150"
              >
                <template slot-scope="scope">
                  <span class="no-tax-price">{{
                    scope.row.pricing.totalPriceStr
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="網卡項目" width="150">
                <template slot-scope="scope" v-if="scope.row.networkCardSouece">
                  <span>{{ scope.row.networkCardSouece.cardName }}</span>
                </template>
              </el-table-column>

              <el-table-column align="left" label="網卡金額" width="80">
                <template slot-scope="scope" v-if="scope.row.networkCardSouece">
                  <span style="font-size: 17px"
                    >${{ scope.row.networkCardSouece.price }}</span
                  >
                </template>
              </el-table-column>

              <el-table-column align="left" label="網卡數量" width="80">
                <template slot-scope="scope" v-if="scope.row.networkCardSouece">
                  <span style="font-size: 17px">{{
                    scope.row.networkCardCount
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                label="網卡使用總金額(含稅)"
                width="150"
              >
                <template slot-scope="scope">
                  <span class="tax-price">{{
                    scope.row.pricing.networkCardUseTotalPriceTaxStr
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                label="App使用總金額(含稅)"
                width="150"
              >
                <template slot-scope="scope">
                  <span class="tax-price"
                    >${{ scope.row.pricing.appUseTotalPriceTax }}</span
                  >
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                label="App使用總金額(未稅)"
                width="150"
              >
                <template slot-scope="scope">
                  <span class="no-tax-price">{{
                    scope.row.pricing.appUseTotalPriceStr
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="團號" width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.tourGroupNo }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="出團日" width="110">
                <template slot-scope="scope">
                  <span>{{ scope.row.beginDate }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="結束日" width="110">
                <template slot-scope="scope">
                  <span>{{ scope.row.endDate }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="團名" width="350">
                <template slot-scope="{ row }">
                  <span>{{ row.travelName }}</span>
                  <div>
                    <el-tag>
                      出發{{ `${row.beginDate} ${row.beginTime}` }} - 回程{{
                        `${row.endDate} ${row.endTime}`
                      }}
                    </el-tag>
                  </div>
                </template>
              </el-table-column>

              <el-table-column align="center" label="狀態" width="110">
                <template slot-scope="scope">
                  <el-tag :type="statusTranslateStyle(scope.row.status)">{{
                    scope.row.statusDesc
                  }}</el-tag>
                </template>
              </el-table-column>

              <el-table-column align="center" label="天數" width="80">
                <template slot-scope="scope">
                  <span style="font-size: 17px">{{ scope.row.totalday }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="旅客數" width="80">
                <template slot-scope="scope">
                  <span style="font-size: 17px">{{ scope.row.tourist }}</span>
                </template>
              </el-table-column>

            </el-table>
          </div>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini" type="danger"
          >關 閉</el-button
        >
      </span>
    </el-dialog> -->

    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <!-- <el-form-item label="查詢">
          <el-input v-model="listQuery.qry" placeholder="輸入團號或團名稱" />
        </el-form-item> -->
        <el-form-item label="旅行社">
          <el-select v-model="listQuery.agencyCode" filterable placeholder="請選擇旅行社" clearable>
            <el-option
              v-for="item in agencyList"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="回程區間">
          <el-date-picker
            v-model="listQuery.dateFilter"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList">查詢</el-button>
        </el-form-item>

        <el-form-item v-if="list && list.length > 0">
          <el-button type="warning" @click="exportExcel" icon="el-icon-download"
            >下載Excel</el-button
          >
        </el-form-item>

        <el-form-item>
          <el-alert type="success" effect="dark" style="margin: 3px" :closable="false">
            <template slot="title">
              計算區間：例.2022-09-26-2022-10-25，以行程結束日於此區間內做為呈現。
            </template>
          </el-alert>
        </el-form-item>

        <!-- <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh()"
          ></el-button>
        </el-form-item> -->
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
        :cell-style="cellStyle"
      >
        <el-table-column align="center" label="項次" width="60" fixed>
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="統編" width="120" fixed>
          <template slot-scope="scope">
            <span style="font-size: 15px; color: #1890ff; font-weight: bold">{{
              scope.row.vatNumber
            }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="旅行社名稱" width="200" fixed>
          <template slot-scope="scope">
            <span style="font-size: 15px; color: #1890ff; font-weight: bold">{{
              scope.row.agencyName
            }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="總金額(含稅)" width="130">
          <template slot-scope="scope">
            <span
              style="font-size: 15px; color: #1890ff; font-weight: bold"
              v-if="scope.row.pricing"
              >{{ scope.row.pricing.totalPriceTaxStr }}</span
            >
          </template>
        </el-table-column>

        <el-table-column align="left" label="App金額(含稅)" width="130">
          <template slot-scope="scope">
            <span
              style="font-size: 15px; color: #1890ff; font-weight: bold"
              v-if="scope.row.pricing"
              >{{ scope.row.pricing.appUseTotalPriceTaxStr }}</span
            >
          </template>
        </el-table-column>

        <el-table-column align="left" label="App金額(未稅)" width="130">
          <template slot-scope="scope">
            <span
              style="font-size: 15px; color: #1890ff; font-weight: bold"
              v-if="scope.row.pricing"
              >{{ scope.row.pricing.appUseTotalPriceStr }}</span
            >
          </template>
        </el-table-column>

        <el-table-column align="left" label="App金額(稅金)" width="150">
          <template slot-scope="scope">
            <span
              v-if="scope.row.pricing"
              style="font-size: 15px; color: green; font-weight: bold"
              >{{ scope.row.pricing.appUseTotalTaxStr }}</span
            >
          </template>
        </el-table-column>

        <el-table-column align="left" label="網卡金額(含稅)" width="130">
          <template slot-scope="scope">
            <span
              style="font-size: 15px; color: #1890ff; font-weight: bold"
              v-if="scope.row.pricing"
              >{{ scope.row.pricing.networkCardUseTotalPriceTaxStr }}</span
            >
          </template>
        </el-table-column>

        <el-table-column align="left" label="網卡金額(未稅)" width="130">
          <template slot-scope="scope">
            <span
              style="font-size: 15px; color: #1890ff; font-weight: bold"
              v-if="scope.row.pricing"
              >{{ scope.row.pricing.networkCardUseTotalPriceStr }}</span
            >
          </template>
        </el-table-column>

        <el-table-column align="left" label="網卡金額(稅金)" width="150">
          <template slot-scope="scope">
            <span
              v-if="scope.row.pricing"
              style="font-size: 15px; color: green; font-weight: bold"
              >{{ scope.row.pricing.networkCardTotalTaxStr }}</span
            >
          </template>
        </el-table-column>

        <el-table-column align="left" label="網卡運費(含稅)" width="150">
          <template slot-scope="scope">
            <span
              v-if="scope.row.pricing"
              style="font-size: 15px; color: #1890ff; font-weight: bold"
              >{{ scope.row.pricing.networkCardPostFeePriceTaxStr }}</span
            >
          </template>
        </el-table-column>

        <el-table-column align="left" label="網卡運費(未稅)" width="150">
          <template slot-scope="scope">
            <span
              v-if="scope.row.pricing"
              style="font-size: 15px; color: #1890ff; font-weight: bold"
              >{{ scope.row.pricing.networkCardPostFeePriceStr }}</span
            >
          </template>
        </el-table-column>

        <el-table-column align="left" label="網卡運費(稅金)" width="150">
          <template slot-scope="scope">
            <span
              v-if="scope.row.pricing"
              style="font-size: 15px; color: green; font-weight: bold"
              >{{ scope.row.pricing.networkCardPostFeeTaxStr }}</span
            >
          </template>
        </el-table-column>

        <el-table-column align="left" label="電話" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.tel }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="負責人" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.boss }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="付款日" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.paymentDate }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="結帳日" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.checkOutDate }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column align="left" label="結帳月份" width="200">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.dates"
              filterable
              placeholder="請選擇"
              value-key="id"
            >
              <el-option
                v-for="item in dates"
                :key="item.id"
                :label="`${item.year}-${item.month}`"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column> -->

        <el-table-column align="left" label="旅行社代碼" width="190">
          <template slot-scope="scope">
            <span>{{ scope.row.agencyCode }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="管理" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button
              :disabled="scope.row.invoiceInfo.data == null"
              @click="getAgencyReceivableList(scope.row)"
              type="success"
              size="mini"
              >查看</el-button
            >

            <el-button @click="openFileDialog(scope.row)" type="primary" size="mini"
              >單據管理</el-button
            >
            <el-button @click="openNoteDialog(scope.row)" type="success" size="mini"
              >備註管理</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import { htmlEncode, htmlDecode } from '@/utils/funcs'

var defaultPricing = {
  networkCardTotalTax: 0,
  networkCardTotalTaxStr: '$0',
  networkCardUseTotalPrice: 0,
  networkCardUseTotalPriceStr: '$0',
  networkCardUseTotalPriceTax: 0,
  networkCardUseTotalPriceTaxStr: '$0',
  appUseTotalPriceTax: 0,
  appUseTotalPriceTaxStr: '$0',
  appUseTotalPrice: 0,
  appUseTotalPriceStr: '$0',
  appUseTotalTax: 0,
  appUseTotalTaxStr: '$0',
  totalPriceTax: 0,
  totalPriceTaxStr: '$0',
}

import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'
import { convertFileToBase64 } from '@/utils/funcs'
import request from '@/utils/request'
import Tinymce from '@/components/Tinymce'
import TravelersUsed from '../components/travelersUsedDetailsComponent.vue'

import {
  getCheckOutYearMonth,
  getAgencies,
  savePropertyDocuments,
  savePaymentInvoiceNote,
} from '@/api/agency'

import { getAgencyOptions } from '@/api/travel'

var defaultForm = {
  viewPointName: '',
  lat: 0,
  lng: 0,
}

export default {
  name: 'AccountsReceivableManagement',
  components: {
    Pagination,
    Upload: () => import('@/views/ita/components/fileUpload.vue'),
    Tinymce,
    TravelersUsed,
  },
  data() {
    return {
      currentTravelID: null,
      currentTravelName: null,
      travelersDetailsDialogNoteVisible: false,
      dialogNoteVisible: false,
      dialogNoteLoading: false,
      agencyList: [],
      sumPrice: null,
      currencAgencyRow: null,
      formData: {
        agencyCode: null,
        year: null,
        month: null,
        fileIDs: [],
        file1: [],
        file2: [],
      },
      fileObj: { id: 0, type: 'agencyReceivableFile', user: '' },
      dialogFileLoading: false,
      dialogFileVisible: false,
      currentAgencyReceivableRow: null,
      currentAgencyReceivableListRow: null,
      funcName: '旅遊團',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        agencyCode: null,
        dateFilter: [],
        dates: null,
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
        filterType: 3,
      },
      total: 0,
      list: [],
      dates: [],
      doing: false,
    }
  },
  async created() {
    this.form = defaultForm
    // this.defaultDates();
    await this.getAgencyOptions()
    await this.getCheckOutYearMonth()
    await this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery.qry = ''
      this.listQuery.date = ''
      this.listQuery.status = null
      this.listQuery.page = 1
      this.listQuery.limit = 20
      this.listQuery.sort = '-id'
      this.listQuery.filterType = 3
      await this.getList()
    },
    async getTravelersDetails(row) {
      this.currentTravelID = row.id
      this.currentTravelName = row.travelName
      this.travelersDetailsDialogNoteVisible = true
    },
    async savePaymentInvoiceNote() {
      let vm = this
      vm.dialogNoteLoading = true
      let agencyCode = vm.currentAgencyReceivableListRow.agencyCode
      let content = vm.currentAgencyReceivableListRow.note.content
      if (content) {
        content = htmlEncode(content)
      }

      let payload = { agencyCode, content }
      try {
        let resp = await savePaymentInvoiceNote(payload)
        vm.$message({
          message: '備註已儲存成功',
          type: 'success',
        })
      } catch (error) {
        console.log(error)
      } finally {
        vm.dialogNoteLoading = false
      }
    },
    defaultDates() {
      const date1 = new Date()
      date1.setTime(date1.getTime() - 3600 * 1000 * 24 * 30)
      const date2 = new Date()
      this.listQuery.dateFilter[0] = date1
      this.listQuery.dateFilter[1] = date2
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex >= 4 && columnIndex <= 6) {
        return 'background-color: floralwhite'
      }
      if (columnIndex >= 7 && columnIndex <= 9) {
        return 'background-color: beige'
      }
    },
    async getAgencyOptions() {
      await getAgencyOptions().then(response => {
        this.agencyList = response.data
      })
    },
    statusTranslateStyle(status) {
      let r = ''
      switch (status) {
        case 0:
          r = 'info'
          break
        case 1:
          r = 'success'
          break
        case 2:
          r = 'warning'
          break
        case 3:
        case 4:
          r = 'danger'
          break
        default:
          break
      }
      return r
    },
    async exportExcel() {
      let vm = this
      let payload = vm.list
      const url = `/Agency/getAgencyReceivableExcel`
      try {
        let response = await request({
          url: url,
          method: 'post',
          data: payload,
          // headers: {
          //   "Content-Type": "application/octet-stream",
          // },
          responseType: 'blob',
        })

        let rightNow = new Date()
        let res = rightNow.toISOString().slice(0, 10).replace(/-/g, '')
        const a = document.createElement('a')
        const u = window.URL.createObjectURL(response)
        a.href = u
        a.download = `應收帳款_${res}.xlsx`
        a.click()

        this.$notify({
          title: '成功',
          message: '應收帳款Excel處理完成',
          type: 'success',
        })
      } catch (error) {
        switch (error.status) {
          case 404:
            alert('尚未有應收帳款產生，無法產出Excel。')
            break
          case 456:
            alert('未設定結帳日，無法產出Excel。')
            break
          default:
            break
        }

        console.log('error', error)
      }

      // let resp = await getTravelsOpinionSurveyReplyDetailsAllToPdf({
      //   travelID,
      // });
      // console.log(resp);
      // this.opinionSurveyPdfTopics = resp.data;
      // this.dialogSurveyUserAnsStatisticsVisible = true;
      // this.listLoading = false;
    },
    onDialogClosed() {
      let refUpload1 = this.$refs['uploadRef1']
      refUpload1.clearFiles()
      let refUpload2 = this.$refs['uploadRef2']
      refUpload2.clearFiles()
    },
    filterFiles(type, files) {
      let result = []
      switch (type) {
        case 1: // 未上傳檔案
          result = files.filter(f => {
            return typeof f.raw !== 'undefined'
          })
          break
        case 2: // 已上傳檔案ID
          files
            .filter(f => {
              return typeof f.raw === 'undefined'
            })
            .forEach(f => {
              result.push(f.uid)
            })

          break
      }
      return result
    },
    async saveData() {
      let vm = this
      if (!vm.currentAgencyReceivableListRow) {
        alert(`請重新於列表上選擇一筆資料。`)
        return
      }

      if (!confirm(`確定要上傳檔案?`)) {
        return
      }

      vm.dialogFileLoading = true

      const f1 = vm.$refs['uploadRef1']
      const f2 = vm.$refs['uploadRef2']

      vm.formData.fileIDs = []
      vm.formData.fileInfo = []

      let payload = {
        agencyCode: vm.currentAgencyReceivableListRow.agencyCode,
        year: vm.currentAgencyReceivableListRow.dates.year,
        month: vm.currentAgencyReceivableListRow.dates.month,
        fileIDs: [],
        file1: [],
        file2: [],
        fileInfo: [],
      }

      const filteFile1Rel1 = this.filterFiles(1, f1.fileList)
      const filteFile1Rel2 = this.filterFiles(1, f2.fileList)

      const oldFileIDs = [...this.filterFiles(2, f1.fileList), ...this.filterFiles(2, f2.fileList)]

      oldFileIDs.forEach(f => {
        // 舊檔案ID
        payload.fileIDs.push(f)
      })

      // base64版本
      // 請款單
      let fileModel1 = {
        type: 21,
        files: [],
      }
      for (var i = 0; i < filteFile1Rel1.length; i++) {
        const f = filteFile1Rel1[i]

        await convertFileToBase64(f.raw).then((resolve, reject) => {
          fileModel1.files.push({
            fileName: f.name,
            base64: resolve,
          })
        })
      }

      payload.fileInfo.push(fileModel1)

      // 發票
      let fileMode2 = {
        type: 22,
        files: [],
      }
      for (var i = 0; i < filteFile1Rel2.length; i++) {
        const f = filteFile1Rel2[i]

        await convertFileToBase64(f.raw).then((resolve, reject) => {
          fileMode2.files.push({
            fileName: f.name,
            base64: resolve,
          })
        })
      }
      payload.fileInfo.push(fileMode2)

      try {
        let resp = await savePropertyDocuments(payload)
        await vm.getList()
        Message({
          message: '資料處理完成',
          type: 'success',
          duration: 5 * 1000,
        })
      } catch (error) {
        console.log(error)
      } finally {
        vm.dialogFileLoading = false
      }
    },
    openNoteDialog(row) {
      let vm = this
      vm.currentAgencyReceivableListRow = row
      if (this.$refs['tinymce']) {
        this.$refs['tinymce'].setValue(vm.currentAgencyReceivableListRow.note.content)
      }

      vm.dialogNoteVisible = true
    },
    onNoteDialogClosed() {},
    async openFileDialog(row) {
      let vm = this
      vm.getFiles(row)

      vm.currentAgencyReceivableListRow = row
      this.dialogFileVisible = true
    },
    async getAgencyReceivableList(row) {
      if (!row.invoiceInfo.data) {
        alert(`查無資料。`)
        return
      }
      let vm = this
      if (!row.pricing) {
        row.pricing = JSON.parse(JSON.stringify(defaultPricing))
      }
      vm.currentAgencyReceivableListRow = row
      vm.dialogVisible = true
    },
    async getFiles(row) {
      let vm = this
      try {
        let respFiles = JSON.parse(JSON.stringify(row.invoiceInfo))

        if (!respFiles.fileInfo) {
          respFiles.fileInfo = []
        }
        // vm.formData = JSON.parse(
        //   JSON.stringify(this.currentAgencyReceivableRow)
        // );
        vm.formData.file1 = []
        vm.formData.file2 = []

        const file1 = respFiles.fileInfo.filter(v => {
          return v.type == 21
        })
        const file2 = respFiles.fileInfo.filter(v => {
          return v.type == 22
        })

        if (file1.length > 0) {
          vm.formData.file1 = file1[0].files
        } else {
          vm.formData.file1 = []
        }
        if (file2.length > 0) {
          vm.formData.file2 = file2[0].files
        } else {
          vm.formData.file2 = []
        }
      } catch (error) {
      } finally {
        this.listLoading = false
      }
    },
    async getCheckOutYearMonth() {
      let resp = await getCheckOutYearMonth()
      this.dates = resp.data
    },
    addData() {
      this.dialogVisible = true
    },
    editData(row) {
      this.form = row
      this.dialogVisible = true
    },
    async getList() {
      let vm = this
      if (!vm.listQuery.dateFilter || vm.listQuery.dateFilter.length < 2) {
        alert(`請輸入日期區間。`)
        return
      }
      vm.listLoading = true

      try {
        let resp = await getAgencies(vm.listQuery)
        resp.data.data.forEach(f => {
          f.dates = vm.dates[0]
          if (!f.pricing) {
            f.pricing = JSON.parse(JSON.stringify(defaultPricing))
          }

          if (!f.note) {
            f.note = JSON.parse(JSON.stringify({ agencyCode: f.agencyCode, content: '' }))
          } else {
            if (f.note.content) {
              f.note.content = htmlDecode(f.note.content)
            }
          }
        })

        vm.list = resp.data.data
        vm.total = resp.data.total
      } catch (error) {
      } finally {
        vm.listLoading = false
      }
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}

.no-tax-price {
  font-size: 17px;
  color: blue;
  font-weight: bold;
}

.tax-price {
  font-size: 17px;
  color: green;
  font-weight: bold;
}

.accountsPayableManagement-app-container div.el-dialog__body {
  position: relative;
  height: 86%;
}
</style>
